<div class="content">
    <h2 class="page-title">{{ "GENERAL.DEPARTMENT" | translate }}</h2>
    <p><strong>Bem vindo a página da arbitragem da CBT</strong></p>

    <p>
        Esta nova área do nosso site servirá para informar regularmente tudo o
        que acontece na área da arbitragem brasileira. Assuntos como cursos de
        arbitragem, perguntas e respostas frequentes, colunistas, regulamentos
        entre outros estarão sempre atualizados para você.
    </p>

    <p>
        O Departamento de Arbitragem teve o início das atividades em janeiro de
        1999 com o seu principal objetivo, naquela época, &nbsp;de preparar e
        coordenar a arbitragem dos torneios nacionais infanto-juvenis e seniors.
    </p>

    <p>
        Os cursos voltaram a ser realizados atendendo aos pedidos de todas as
        Federações Estaduais, sempre em busca de uma padronização dos
        procedimentos adotados nos torneios nacionais.
    </p>

    <p>
        Em pouco tempo pudemos detectar uma melhora significante na condução dos
        torneios nacionais, fazendo com que vários novos árbitros surgissem e
        pudessem ter a arbitragem como sua atividade principal e
        consequentemente oferecer um melhor serviço aos nossos tenistas.
    </p>

    <p>
        Boa parte desse grupo de árbitros seguiu investindo na carreira e,
        atualmente, vários deles possuem certificações internacionais e atuam em
        vários torneios profissionais, inclusive fora do país. O Brasil,
        mantendo a tradição na arbitragem de tênis, orgulha-se de ser o país com
        o maior número de árbitros certificados na América Latina!
    </p>

    <p>
        Atualmente o Departamento realiza regularmente os cursos de arbitragem
        em todos os estados do país, além de assessorar os torneios
        profissionais e amadores na seleção dos árbitros para os mais variados
        tipos de eventos de tênis.
    </p>

    <p>
        Algumas partes de nossa página ainda não estão terminadas e por isso
        nosso pedido de desculpas. Nos próximos dias você terá acesso a todo o
        conteúdo que estamos preparando e esperamos que você e seus amigos do
        tênis desfrutem das informações disponíveis.
    </p>

    <p>Um abraço</p>

    <p>
        <strong>Ricardo Reis</strong><br />
        <em>Diretor do Departamento de Arbitragem</em>
    </p>
</div>
